export class addOrModifyConfiguration {
    constructor(productName, configurationName, description, value) {
        this.productName = productName;
        this.configurationName = configurationName;
        this.description = description;
        this.value = value;
    }
}